module.exports = __webpack_public_path__ + "static/img/despierto.7b1771b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/despierto.png
// module id = 215
// module chunks = 1